import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { CoreService } from 'src/app/services/core.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderService } from 'src/app/services/loader.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { CartStorage } from 'src/app/storage/cart';
import { OwlOptions } from 'ngx-owl-carousel-o';

// declare var fbq: Function;

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss']
})

export class StoreComponent implements OnInit {
  defImgProd: string = "assets/logos-nina/nina2_placeholder_cuadrado.jpg";
  defImgBanner: string = "assets/logos-nina/nina2_placeholder_banner2.jpg";
  lines: any = [];
  products: any = [];
  filteredProducts: any = [];
  api: string = environment.photosUrl;
  token: string = "";
  apiKey: string = environment.apiKey;
  searchText: string = "";
  searchLine: number = 0;
  dataSource: any = [];
  cookieBranch: any = {}
  obs: any

  paginator!: MatPaginator;

  @ViewChild(MatPaginator)
  set paginatorRef(paginator: MatPaginator) {
    if (paginator) {
      this.paginator = paginator;

      if (this.dataSource instanceof MatTableDataSource) {
        this.dataSource.paginator = paginator;
      }
    }
  }

  @ViewChild('categoriesScroller') categoriesScroller!: ElementRef<HTMLDivElement>;

  scrollCategories(direction: 'left' | 'right'): void {
    const container = this.categoriesScroller?.nativeElement;
    if (!container) return;

    container.scrollBy({
      left: direction === 'left' ? -350 : 350,
      behavior: 'smooth'
    });
  }

  @ViewChild('linesContainer') linesContainer!: ElementRef<HTMLDivElement>;
    scrollLines(direction: 'left' | 'right'): void {
      const container = this.linesContainer?.nativeElement;
      if (!container) return;

      container.scrollBy({
        left: direction === 'left' ? -350 : 350,
        behavior: 'smooth'
      });
    }

  pageEvent: any;

  banners: any = [];

  promoOptions: OwlOptions = {
    loop: true,
    autoHeight: true,
    autoWidth: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    responsiveRefreshRate: 1000,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      1100: {
        items: 3
      },
      1400: {
        items: 4
      }
    }
  };

  constructor(private cdr: ChangeDetectorRef, private loaderService: LoaderService, private coreService: CoreService, public dialog: MatDialog, public apiServices: ApiService, public cookies: CookieService, public route: ActivatedRoute, public router: Router) {
    if (cookies.check('Token')) {
      this.token = cookies.get('Token')
    }

    this.searchText = this.route.snapshot.queryParams['filter'] ?? "";
    this.searchLine = this.route.snapshot.queryParams['line'] ?? 0;
    if (this.searchLine != 0) {
      this.searchLine = Number(this.searchLine)
    }
  }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.searchLine = Number(params['line'] ?? 0);

      this.selectLineFromUrl();
    });

    this.coreService.emitSubjet.subscribe(response => {
      if (response.type === 'ProductSearch') {
        this.searchText = response.payload.text;
        if (this.searchText !== '') {
          this.searchLine = 0;
          this.lines = this.lines.map((line: any) => ({
            ...line,
            selected: false
          }));
          this.applyFilter();
        }
        else {
          this.searchLine = 0;
          this.filteredProducts = [...this.products];
          this.dataSource = new MatTableDataSource<any>(
            this.filteredProducts
          );
          this.dataSource.paginator = this.paginator;
          this.obs = this.dataSource.connect();
          this.lines = this.lines.map((line: any) => ({
            ...line,
            selected: false
          }));
          this.cdr.detectChanges();
        }
      }

      else if (response.type === 'ClearProductSearch') {
        this.searchText = '';
        this.cdr.detectChanges();
      }
    });

    this.getBanners();
    this.getLineas();
    this.getProductosAgrupados();
  }

  selectLineFromUrl() {
    const filter = this.route.snapshot.queryParams['filter'] ?? '';
    if (filter !== '') {
      this.searchText = filter;
      this.searchLine = 0;
      this.lines = this.lines.map((line: any) => ({
        ...line,
        selected: false
      }));
      if (this.products.length > 0) {
        this.applyFilter();
      }
      this.cdr.detectChanges();
      return;
    }
    if (this.searchLine <= 0 || this.lines.length === 0) {
      return;
    }
    const selectedLine = this.lines.find(
      (line: any) =>
        Number(line.idLineaApp) === Number(this.searchLine)
    );
    if (!selectedLine) {
      return;
    }
    this.lines = this.lines.map((line: any) => ({
      ...line,
      selected:
        Number(line.idLineaApp) === Number(this.searchLine)
    }));
    if (this.products.length > 0) {
      this.applyFilterLine();
    }
    this.cdr.detectChanges();
  }

  getBanners() {
    this.loaderService.show();

    const data = {
      token: this.cookies.get('Token')
    };

    this.apiServices.getBanners(data).subscribe({
      next: (value) => {
        this.banners = value;
        this.loaderService.hide();
      },
      error: (err) => {
        this.loaderService.hide();
      }
    });
  }

  goToPromotions() {
    this.router.navigate(['/promotions']);
  }

  selectLine(line: any) {
    this.searchText = '';
    this.coreService.emitSubjet.next({
      type: 'ClearProductSearch',
      payload: null
    });

    this.lines = this.lines.map(
      (item: any) => ({
        ...item,
        selected: item.idLineaApp === line.idLineaApp
      })
    );

    this.searchLine = Number(line.idLineaApp);
    this.router.navigate(
      ['/store'],
      {
        queryParams: {
          line: this.searchLine
        },
        replaceUrl: true
      }
    );
    this.paginator?.firstPage();
    this.applyFilterLine();
  }

  clearLineFilter() {
    this.searchLine = 0;
    this.searchText = '';
    this.lines = this.lines.map(
      (line: any) => ({
        ...line,
        selected: false
      })
    );
    this.coreService.emitSubjet.next({
      type: 'ClearProductSearch',
      payload: null
    });
    this.filteredProducts = [...this.products];
    this.dataSource = new MatTableDataSource<any>(
      this.filteredProducts
    );
    this.dataSource.paginator = this.paginator;
    this.obs = this.dataSource.connect();
    this.paginator?.firstPage();
    this.router.navigate(
      ['/store'],
      {
        queryParams: {},
        replaceUrl: true
      }
    );

    this.cdr.detectChanges();
  }

  getStoreTitle(): string {
    if (this.searchLine > 0) {
      const selectedLine = this.lines.find(
        (line: any) => line.idLineaApp === this.searchLine
      );
      if (selectedLine) {
        return selectedLine.descripcion;
      }
    }
    return 'Todos nuestros productos';
  }

  goToBanner(selectedBanner: any) {
    if (selectedBanner.idPromocion == 0) {
      if (selectedBanner.link) {
        window.open(
          selectedBanner.urlLink,
          '_blank'
        );
      }
    }
    else {
      if (
        selectedBanner.idPromocion &&
        selectedBanner.tipoPromo
      ) {
        this.coreService.emitSubjet.next({
          type: 'PromoBanner',
          payload: {
            idPromo: selectedBanner.idPromocion,
            tipoPromo: selectedBanner.tipoPromo
          }
        });
      }
    }
  }

  getProductosAgrupados() {
    if (this.cookies.check("Branch")) {
      this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
      let data = { token: this.cookies.get('Token'), idSucursal: this.cookieBranch.idSucursal }
      this.loaderService.show()
      this.apiServices.getProdutosAgrupadoresPorSucursal(data).subscribe({
        next: (value) => {
          this.products = value;
          this.filteredProducts = [...this.products]
          this.dataSource = new MatTableDataSource<any>(this.filteredProducts)
          this.dataSource.paginator = this.paginator;
          this.obs = this.dataSource.connect()
          if (this.searchText.length > 0) {
            this.applyFilter()
          }

          if (this.searchLine > 0) {
            this.applyFilterLine()
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }
    else {
      this.loaderService.show()
      let data = { token: this.cookies.get('Token') }
      this.apiServices.getProductoAgrupador(data).subscribe({
        next: (value) => {
          this.products = value;
          this.filteredProducts = [...this.products]
          this.dataSource = new MatTableDataSource<any>(this.filteredProducts)
          this.dataSource.paginator = this.paginator;
          this.obs = this.dataSource.connect();
          if (this.searchText.length > 0) {
            this.applyFilter()
          }

          if (this.searchLine > 0) {
            this.applyFilterLine()
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }
  }

  getProductos() {
    let data = { token: this.cookies.get('Token') }
    this.loaderService.show()
    this.apiServices.getProductos(data).subscribe({
      next: (value) => {
        this.products = value;
        this.filteredProducts = [...this.products]
        this.dataSource = new MatTableDataSource<any>(this.filteredProducts)
        this.dataSource.paginator = this.paginator;
        this.obs = this.dataSource.connect();
        if (this.searchText.length > 0) {
          this.applyFilter()
        }

        if (this.searchLine > 0) {
          this.applyFilterLine()
        }
        this.loaderService.hide()
      },
      error: (err) => {
        this.loaderService.hide()
      }
    })
  }

  async applyFilter() {
    this.searchLine = 0;
    this.lines = this.lines.map((line: any) => ({
      ...line,
      selected: false
    }));
    this.filteredProducts = [...this.products];
    this.dataSource = new MatTableDataSource<any>(
      this.filteredProducts
    );
    this.dataSource.paginator = this.paginator;
    this.obs = this.dataSource.connect();
    this.dataSource.filter = this.searchText.trim().toLowerCase();
    this.paginator?.firstPage();
    this.cdr.detectChanges();
  }

  applyFilterLine() {
    this.filteredProducts = [...this.products.filter((product: any) => product.idLineaApp === this.searchLine)];
    this.dataSource = new MatTableDataSource<any>(this.filteredProducts)
    this.dataSource.paginator = this.paginator;
    this.obs = this.dataSource.connect()
    this.paginator?.firstPage();
    this.cdr.detectChanges();
  }

  getLineas() {
    if (this.cookies.check("Branch")) {
      this.loaderService.show()
      this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
      let data = { token: this.cookies.get('Token'), idSucursal: this.cookieBranch.idSucursal }
      this.apiServices.getLineasSucursal(data).subscribe({
        next: (value) => {
          // console.log("With branch" ,value)
          this.lines = value.map((line: any) => ({
            ...line,
            selected: false
          }));

          this.selectLineFromUrl();

          this.loaderService.hide();
        },
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }
    else {
      let data = { token: this.cookies.get('Token') }
      this.loaderService.show()
      this.apiServices.getLineas(data).subscribe({
        next: (value) => {
          // console.log("Without branch" ,value)
          this.lines = value.map((line: any) => ({
            ...line,
            selected: false
          }));

          this.selectLineFromUrl();

          this.loaderService.hide();
        },
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }
  }

  changeSelectedChip(event: any, idLineaApp: number) {
    if (event.selected) {
      this.selectLine({
        idLineaApp: idLineaApp
      });
    }
    else {
      this.clearLineFilter();
    }
  }

  selectedProduct(product: any) {
    const dialogRef = this.dialog.open(DialogDetailProduct, {
      width: '95vw',
      maxWidth: '1200px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'product-detail-dialog',
      backdropClass: 'nina-dialog-backdrop',
      autoFocus: false,
      data: {
        product: product,
        lines: this.lines
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getLineas();
      this.getProductosAgrupados();
      this.products = [];
      this.filteredProducts = [...this.products];
      this.dataSource = new MatTableDataSource<any>(this.products);
      this.dataSource.paginator = this.paginator;
      this.obs = this.dataSource.connect();
    });
  }
}

@Component({
  selector: 'dialog-detail-product',
  templateUrl: 'dialog-detail-product.html',
  styleUrls: ['dialog-detail-product.scss']
})

export class DialogDetailProduct {
  defImgProd: string = "assets/img/logo_nina_placeholder.jpg"
  baseData: any;
  product: any;
  lines: any = [];
  line: any = null
  productsFullData: any = [];
  qty: number = 1;
  price: number = 0;
  cookieBranch: any = {}
  cart: any = []

  constructor(private loaderService: LoaderService, private coreService: CoreService, public dialogRef: MatDialogRef<DialogDetailProduct>, @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, public cookies: CookieService, public apiServices: ApiService, private gtm: GoogleTagManagerService) {
    this.baseData = data.product;
    this.product = data.product
    this.lines = data.lines
    this.line = this.lines.find((line: any) => this.product.idLineaApp === line.idLineaApp)
    this.defImgProd = this.product.urlFoto
    this.gtm.pushTag({ event: 'view_item', line_id: this.product.idLineaApp });

  }

  ngOnInit(): void {
    this.getProductoByIDAgrupado()

    this.coreService.emitSubjet.subscribe(response => {
      if (response.type === 'RefreshDetail') {
        this.getProductoByIDAgrupado()
      }
      else if (response.type === 'CloseDetail') {
        this.dialogRef.close();
      }
    })
  }

  addCart() {
    this.gtm.pushTag({ event: 'add_to_cart', product_id: this.product.idProducto });
    this.cart = [];
    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (CartStorage.exists()) {
      this.cart = CartStorage.getCart()
      const index = this.cart.findIndex((item: any) => item.idProducto === this.product.idProducto);
      if (index !== -1) {
        this.cart[index].qty = this.qty;
        this.qty = this.cart[index].qty
      }
      else {
        this.cart.push({ idProducto: this.product.idProducto, idProductoAgrupador: this.baseData.idProductoAgrupador, nombre: this.product.productoAgrupador, qty: this.qty });
      }
      CartStorage.saveCart(this.cart)
      this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Producto Agregado al Carrito" } });
      this.coreService.emitSubjet.next({ type: 'Cart', payload: null });
    }
    else {
      if (!this.cookies.check("UL")) {
        this.coreService.emitSubjet.next({ type: 'LoginExternal', payload: null });
      }
      else {
        if (this.cookies.get("Branch") !== '') {
          this.cart.push({ idProducto: this.product.idProducto, idProductoAgrupador: this.baseData.idProductoAgrupador, nombre: this.product.productoAgrupador, qty: this.qty });
          CartStorage.saveCart(this.cart)
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Producto Agregado al Carrito" } });
          this.coreService.emitSubjet.next({ type: 'Cart', payload: null });
        }
        else {
          this.coreService.emitSubjet.next({ type: 'ShippingType', payload: { product: this.product, idProductoAgrupador: this.baseData.idProductoAgrupador, qty: this.qty } })
        }
      }

    }
  }

  refreshQty() {
    if (CartStorage.exists()) {
      this.cart = CartStorage.getCart()
      if (this.cart.findIndex((element: any) => element.idProducto === this.product.idProducto) != -1) {
        if (this.cart.find((element: any) => element.idProducto === this.product.idProducto).qty > this.product.existencia) {
          this.qty = this.product.existencia
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "El inventario de este producto que esta en tu carrito cambio y se ajusto" } });
        }
        else {
          this.qty = this.cart.find((element: any) => element.idProducto === this.product.idProducto).qty
        }
        this.price = this.product.precioVenta * this.qty;
      }
    }
  }

  getProductoByIDAgrupado() {
    if (this.cookies.check("Branch")) {
      this.loaderService.show()
      this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
      let data = { token: this.cookies.get('Token'), idSucursal: this.cookieBranch.idSucursal, idAgrupadorProd: this.baseData.idProductoAgrupador }
      this.apiServices.getProductosPorSucursalYProductoAgrupador(data).subscribe({
        next: (value) => {
          this.productsFullData = value;
          // this.product.urlFoto = this.productsFullData.urlFoto
          this.productsFullData.forEach((product: any) => {
            if (product.existencia > 0) {
              product.disabled = false
            }
            else {
              product.disabled = true
            }
            product.selected = false;
          });
          if (this.productsFullData.length > 0) {
            this.product = this.productsFullData[0]
            this.product.urlFoto = this.baseData.urlFoto
            this.price = this.product.precioVenta * this.qty;
            this.productsFullData[0].selected = true;
          }
          this.refreshQty();
          this.loaderService.hide()
        },
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }
    else {
      let data = { token: this.cookies.get('Token'), idAgrupadorProd: this.product.idProductoAgrupador }
      this.loaderService.show()
      this.apiServices.getProductoPorProductoAgrupador(data).subscribe({
        next: (value) => {
          this.productsFullData = value;
          this.productsFullData.forEach((product: any) => {
            if (product.existencia > 0) {
              product.disabled = false
            }
            else {
              product.disabled = true
            }
            product.selected = false;
          });
          if (this.productsFullData.length > 0) {
            this.product = this.productsFullData[0]
            this.price = this.product.precioVenta * this.qty;
            this.productsFullData[0].selected = true;
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }
  }

  changeQty(action: string) {
    if (action === "sumar") {
      if (this.qty < this.product.existencia) {
        this.qty++;
      }
      else {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "No hay suficiente existencia de este producto :(" } });
      }
    }
    else {
      if (this.qty > 1) {
        this.qty--;
      }
    }
    this.price = this.product.precioVenta * this.qty;
  }

  changeSelectedSize(size: any) {
    this.product = size;
    this.price = this.product.precioVenta * this.qty;
  }

  preventTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
